import { createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-250d78c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "contact-us",
  id: "contactus"
}
const _hoisted_2 = {
  key: 0,
  class: "title",
  delay: 100
}
const _hoisted_3 = {
  key: 1,
  class: "subtitle",
  delay: 250
}
const _hoisted_4 = { delay: 350 }
const _hoisted_5 = {
  key: 1,
  class: "thanks"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "thanks-title" }, "Thank you!", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "thanks-description" }, "We'll be in touch shortly.", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ContactUsForm = _resolveComponent("ContactUsForm")!
  const _component_Button = _resolveComponent("Button")!
  const _directive_motion_slide_title_element = _resolveDirective("motion-slide-title-element")!
  const _directive_motion_fade = _resolveDirective("motion-fade")!
  const _directive_motion_fade_visible_once = _resolveDirective("motion-fade-visible-once")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (!_ctx.isEmailSent)
      ? _withDirectives((_openBlock(), _createElementBlock("h1", _hoisted_2, [
          _createTextVNode(" Contact Us ")
        ])), [
          [_directive_motion_slide_title_element]
        ])
      : _createCommentVNode("", true),
    (!_ctx.isEmailSent)
      ? _withDirectives((_openBlock(), _createElementBlock("h3", _hoisted_3, [
          _createTextVNode(" To request a quote or get in touch fill out the form and we will get back to you promptly. ")
        ])), [
          [_directive_motion_slide_title_element]
        ])
      : _createCommentVNode("", true),
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [
      (!_ctx.isEmailSent)
        ? _withDirectives((_openBlock(), _createBlock(_component_ContactUsForm, {
            key: 0,
            onSent: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isEmailSent = true))
          }, null, 512)), [
            [_directive_motion_fade]
          ])
        : _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [
            _hoisted_6,
            _hoisted_7,
            _createVNode(_component_Button, {
              class: "thanks-button",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isEmailSent = false)),
              primary: "",
              text: "Ok"
            })
          ])), [
            [_directive_motion_fade]
          ])
    ])), [
      [_directive_motion_fade_visible_once]
    ])
  ]))
}